module.exports = __webpack_public_path__ + "static/tbc-logo-4c29f04b394eb43e40eadc2f97dfc94f.png";